import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClientTranslationKeyModel } from '../models/language-locale.model';
import { UserEditStorageService } from '../services/user-edit-storage/user-edit-storage.service';

import { TranslationManagerService } from '../services/translation-manager.service';
import { TranslationSearchFilterBarComponent } from '../translation-search-filter-bar/translation-search-filter-bar.component';
import { TranslationTextSearchPipe } from '../pipes/translation-text-search.pipe';

@Component({
	selector: 'client-translation-key-panel',
	templateUrl: './client-translation-key-panel.component.html',
	styleUrls: ['./client-translation-key-panel.component.scss'],
	standalone: true,
	imports: [CommonModule, TranslationSearchFilterBarComponent, TranslationTextSearchPipe]
})
export class ClientTranslationKeyPanelComponent implements OnInit {
	@ViewChild('translationSearchFilterBar', { static: false })
	translationSearchFilterBar: TranslationSearchFilterBarComponent;

	public selectedTranslationKey: ClientTranslationKeyModel = null;

	constructor(
		public translationManagerService: TranslationManagerService,
		private userEditStorageService: UserEditStorageService
	) {}

	ngOnInit(): void {}

	/**
	 * Emits the user selected translation key.
	 * If the user has outstanding form changes, an alert is triggered and no event is emitted.
	 * @param clientTranslationKey The Translation Key selected from the panel
	 * @returns void
	 */
	public emitLoadClientLanguageInfo(clientTranslationKey: ClientTranslationKeyModel): void {
		if (!this.userEditStorageService.hasOutstandingChanges) {
			this.selectedTranslationKey = clientTranslationKey;
		} else {
			alert('You have outstanding changes! Leaving will delete these.');
		}
	}
}
